<div class="heroWrapper">
  <h1 class="headingWL backdrop">
    PM SHRI Schools<span class="ms-2"> Activities</span>
  </h1>
</div>
<div
  class="mainContainer d-flex gap-5 flex-column justify-content-center my-5 align-items-center"
>
  <div class="infoWrap d-flex gap-5 align-items-center">
    <img class="mainImg" src="assets/images/pmshri/PMShri.png" alt="Virsa PM Shri Digital Learning Initiative" />
    <p class="vtext mainText">
      The PM SHRI School initiative, led by the Government of India, aims to
      establish 14,500+ schools, overseen by various governmental bodies like
      KVS and NVS. These schools foster an inclusive environment, ensuring
      student well-being, security, and a diverse learning experience with
      quality infrastructure and resources. <br /><br />
      Virsa actively supports schools in meeting the PM SHRI Scheme pillars,
      ensuring they fulfill essential criteria crucial for successful
      implementation and compliance with program requirements.
    </p>
  </div>
  <h2 class="headingBL">Deliverables by <span>Virsa</span></h2>
  <div class="deliverDetails d-flex gap-5 max_width">
    <div
      class="infoWrap d-flex flex-column align-items-center justify-content-center gap-3"
    >
      <div class="info d-flex align-items-center gap-3">
        <p class="vtext w_text">
          Virsa Installs Cutting-Edge Educational Panels for Seamless School
          Integration. The 75” interactive flat panel boasts AI-enabled motion
          camera, Android 12, dual-core ARM, 4GB RAM, 8GB ROM, 64GB Flash, 4K
          resolution, 120-degree viewing angle, 3 USB ports, and dual OS.
        </p>
        <img
          class="image"
          src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/pmshri/data/1.jpg"
          alt=""
        />
      </div>
      <div class="info d-flex align-items-center gap-3">
        <p class="vtext w_text">
          The OPS system features Windows 11, Intel H5 10 Comet Lake, i5 10th
          gen, 1TB SSD, expandable RAM up to 32GB, expandable storage up to 6TB,
          Intel Iris X E Graphics, WI-FI 6, Bluetooth 5.0, and various
          educational applications.
        </p>
        <img
          class="image"
          src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/pmshri/data/3.jpg"
          alt=""
        />
      </div>
    </div>
    <p class="vtext mainText">
      Virsa played a pivotal role in the PM SHRI initiative, hosting
      enlightening expert talks by distinguished leaders. Mr. V.P. Rao IAS
      (Retd) focused on Sustainable Development, while Er. R.S. Pachauri
      conducted sessions emphasizing Computer Literacy and ICT skills.
      Additionally, Mr. Harsh Shrivastava shed light on Media Literacy, and Ms.
      Smita Mittal delivered an informative session on Communication skills.
      These talks enriched the educational landscape, offering crucial insights
      for holistic student development.
    </p>
  </div>
  <h4 class="headingBS">Glim<span>pses</span></h4>
  <div class="glimpsesWrap py-5 max_width">
    <div class="glip_container d-flex flex-column gap-4">
      <img
        class="glimpsesImg"
        src="{{ item.img }}"
        alt=""
        *ngFor="let item of imageArray1"
      />
    </div>
    <div class="glip_container d-flex flex-column gap-4">
      <img
        class="glimpsesImg"
        src="{{ item.img }}"
        alt=""
        *ngFor="let item of imageArray2"
      />
    </div>
    <div class="glip_container d-flex flex-column gap-4">
      <img
        class="glimpsesImg"
        src="{{ item.img }}"
        alt=""
        *ngFor="let item of imageArray3"
      />
    </div>
  </div>
</div>
